import type { MutableRefObject } from 'react';
import { useEffect, useState } from 'react';

/**
 * Custom hook to detect if an element is visible within a container or viewport
 * Uses IntersectionObserver for visibility detection
 */
export const useIsVisible = (
  targetRef: MutableRefObject<HTMLElement | null>,
  threshold: number = 0.01,
  root: MutableRefObject<HTMLElement | null> | null = null
) => {
  const [isVisible, setIsVisible] = useState(true); // default true avoids false-negative on SSR (no IntersectionObserver)

  useEffect(() => {
    const currentElement = targetRef.current;
    if (!currentElement) return undefined;

    const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), {
      threshold,
      root: root?.current || undefined,
    });

    observer.observe(currentElement);
    return () => observer.disconnect();
  }, [targetRef, threshold, root]);

  return isVisible;
};
